import shareModal from 'Components/ShareModal/reducer';
import { combineReducers } from 'redux';

import album from './components/Album/reducer';
import CameraControlModal from './components/CameraControlModal/reducer';
import cards from './components/CardTabs/reducer';
import scheduleModal from './components/ScheduleModal/reducer';
import schedulesTab from './components/Schedules/reducer';
import takeSnapshotModal from './components/TakeSnapshotModal/reducer';
import trimVideoModal from './components/TrimVideoModal/reducer';
import habitatInfo from './reducer/index';

export default combineReducers({
  habitatInfo,
  cards,
  album,
  schedulesTab,
  shareModal,
  scheduleModal,
  CameraControlModal,
  takeSnapshotModal,
  trimVideoModal,
});
